"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FolderHeartSolid: function() {
        return FolderHeartSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FolderHeartSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1 6C1 4.34315 2.34315 3 4 3H8.39445C8.98672 3 9.56575 3.17531 10.0585 3.50385L12.0509 4.83205C12.2151 4.94156 12.4081 5 12.6056 5H20C21.6569 5 23 6.34315 23 8V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6ZM11.9976 10.7119C11.2978 9.9328 10.1309 9.72321 9.25414 10.4367C8.37738 11.1501 8.25394 12.343 8.94247 13.1868C9.27605 13.5956 10.4112 14.8136 11.2746 15.7314C11.6679 16.1495 12.3317 16.1492 12.7247 15.7307C13.5865 14.8129 14.7193 13.5954 15.0527 13.1868C15.7413 12.343 15.6329 11.1426 14.7411 10.4367C13.8492 9.73072 12.6974 9.9328 11.9976 10.7119Z",
        fill: "currentColor"
    })
}), "FolderHeartSolid");
const _default = FolderHeartSolid;
